import React from 'react';

function About() {
    return (
        <div className="p-4 bg-white shadow rounded">
            <h1 className="text-2xl font-bold">About Page</h1>
            <p>This is the about page.</p>
        </div>
    );
}

export default About;
